import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFamilyHistory,
  addFamilyHistory,
  updateFamilyHistory,
  removeFamilyHistory,
} from "../thunks/familyHistoryThunks";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const familySlice = createSlice({
  name: "familyHistory",
  initialState,
  reducers: {
    resetFamilyHistory: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      // ---- FETCH ----
      .addCase(fetchFamilyHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFamilyHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFamilyHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---- ADD ----
      .addCase(addFamilyHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addFamilyHistory.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.data.push(action.payload);
        }
      })
      .addCase(addFamilyHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---- UPDATE ----
      .addCase(updateFamilyHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFamilyHistory.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.data.findIndex((i) => i.id === action.payload?.id);
        if (idx !== -1) state.data[idx] = action.payload;
      })
      .addCase(updateFamilyHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---- DELETE ----
      .addCase(removeFamilyHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeFamilyHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((i) => i.id !== action.payload);
      })
      .addCase(removeFamilyHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFamilyHistory } = familySlice.actions;
export default familySlice.reducer;
